import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "sidebar" ]

  connect() {
    // Initialize sidebar state
    this.isOpen = false

    this.configure();
  }

  configure() {
    if (window.innerWidth < 768) { // Bootstrap md breakpoint
      // Add mobile transition styles
      this.sidebarTarget.style.transition = "transform .6s ease-in-out"
      this.sidebarTarget.style.transform = "translateX(-100%)"
      this.sidebarTarget.classList.remove("d-none")
      this.sidebarTarget.style.position = "fixed"
      this.sidebarTarget.style.top = "0"
      this.sidebarTarget.style.left = "0"
      this.sidebarTarget.style.height = "100vh"
      this.sidebarTarget.style.zIndex = "1050"
    } else {
      // Reset styles for larger viewports
      this.sidebarTarget.style.transition = ""
      this.sidebarTarget.style.transform = ""
      this.sidebarTarget.classList.add("d-none", "d-md-block")
      this.sidebarTarget.style.position = ""
      this.sidebarTarget.style.top = ""
      this.sidebarTarget.style.left = ""
      this.sidebarTarget.style.height = ""
      this.sidebarTarget.style.zIndex = ""
    }
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.updateSidebarVisibility()
  }

  updateSidebarVisibility() {
    if (this.isOpen) {
      this.sidebarTarget.style.transform = "translateX(0)"
    } else {
      this.sidebarTarget.style.transform = "translateX(-100%)"
    }
  }
}
